import style from "../scss/index.scss";


global.$ = global.jQuery = require('jquery');
require('popper.js');
require('bootstrap');

global.LazyLoad = require('vanilla-lazyload/dist/lazyload.min.js');
//require('picturefill');
global.objectFitImages = require('object-fit-images');

//require('lightgallery');
//require('lg-video');
//require('lg-thumbnail');
//require('lg-zoom');

//global.justifiedGallery = require('justifiedGallery');
require('./netteForms');
require('./nette.ajax');


import * as base from './sub/all.js';


window.app = base;

$(function () {
    $.nette.init();



    $('.ajaxOnChange').on('change', function(){
        var form = $(this).closest('form');

        $.nette.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: form.serialize()
        });

        return false;
    })
});


